import { motion, useScroll, useTransform } from 'framer-motion'
import { useRef } from 'react'
import SectionTitle from './SectionTitle'

const About = () => {

  const ref = useRef(null)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"]
  })
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"])

  return (
    <section id="about" className="bg-ds-off-white py-16 sm:py-20 lg:py-28">
      <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-12">
        <SectionTitle title="ABOUT" />

        <div className="grid lg:grid-cols-[25%_1fr] gap-8 sm:gap-10 lg:gap-16 items-center">
          {/* Image */}
          <motion.div
            ref={ref}
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="relative overflow-hidden rounded-tr-3xl rounded-br-3xl shadow-2xl -ml-4 sm:-ml-6 lg:-ml-12">
              <motion.div style={{ y }} className="image-overlay">
                <img
                  src="/about_img.png"
                  alt="Team working on digital products"
                  className="w-full h-56 sm:h-72 lg:h-[450px] object-cover scale-110"
                />
              </motion.div>
            </div>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="space-y-4 sm:space-y-6"
          >
            <p className="font-body text-base lg:text-lg text-ds-navy leading-relaxed">
              Daily Stride LLC is a product-focused technology company dedicated to transforming original ideas into 
              innovative digital solutions. We specialize in conceiving, developing, and managing proprietary mobile and 
              web-based applications that are designed to meet real-world needs.
            </p>
            
            <p className="font-body text-base lg:text-lg text-ds-navy leading-relaxed">
              Unlike agencies or outsourcing firms, all of our concepts originate internally. Each idea is carefully refined, built 
              into a functional product, and managed in-house to ensure quality, compliance, and long-term sustainability.
            </p>
            
            <p className="font-body text-base lg:text-lg text-ds-navy leading-relaxed">
              Our mission is simple: to imagine bold new possibilities, turn them into practical applications, and deliver 
              products that enhance everyday experiences. By owning and managing every stage of development, we 
              maintain full creative control and uphold the highest standards across all platforms.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default About
